class ToolbarSection extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[aria-controls]');
    if (!this.trigger) return;

    const drawerId = this.trigger.getAttribute('aria-controls');
    this.drawer = document.getElementById(drawerId);
    this.overlay = document.getElementById(drawerId.replace('toolbar-drawer-', 'toolbar-overlay-'));

    if (!this.drawer || !this.overlay) return;

    this.closeButton = this.drawer.querySelector('.toolbar-drawer__close');

    this.trigger.addEventListener('click', this.open.bind(this));
    this.overlay.addEventListener('click', this.close.bind(this));
    this.closeButton?.addEventListener('click', this.close.bind(this));
    this.drawer.addEventListener('keydown', this.onDrawerKeydown.bind(this));
    document.addEventListener('keydown', this.onEscape.bind(this));
  }

  open() {
    this.drawer.classList.add('is-active');
    this.overlay.classList.add('is-active');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.overlay.removeAttribute('aria-hidden');
    this.drawer.removeAttribute('aria-hidden');
    document.documentElement.classList.add('overflow-hidden');

    this.closeButton?.focus();
  }

  close() {
    this.drawer.classList.remove('is-active');
    this.overlay.classList.remove('is-active');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.overlay.setAttribute('aria-hidden', 'true');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('overflow-hidden');
    this.trigger.focus();
  }

  onEscape(event) {
    if (event.key === 'Escape' && this.drawer.classList.contains('is-active')) {
      this.close();
    }
  }

  onDrawerKeydown(event) {
    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      this.drawer.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex="0"]'
      )
    ).filter(el => !el.closest('[aria-hidden="true"]'));

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

customElements.define('toolbar-section', ToolbarSection);
